import Typography from '@material-ui/core/Typography';

import styles from './Sidebar.style';

const sharedPropTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element,
  ]),
};

class Sidebar extends React.Component {
  render() {
    const { classes, children } = this.props;

    return <div className={classes.root}>{children}</div>;
  }
}

Sidebar.propTypes = sharedPropTypes;

class SidebarTitle extends React.Component {
  render() {
    const { classes, children } = this.props;

    return <h2 className={classes.title}>{children}</h2>;
  }
}

SidebarTitle.propTypes = sharedPropTypes;

class SidebarHeader extends React.Component {
  render() {
    const { classes, children } = this.props;

    return <div className={classes.header}>{children}</div>;
  }
}

SidebarHeader.propTypes = sharedPropTypes;

class SidebarTypography extends React.Component {
  render() {
    const { classes, children } = this.props;

    return <Typography className={classes.typography}>{children}</Typography>;
  }
}

SidebarTypography.propTypes = sharedPropTypes;

class SidebarActions extends React.Component {
  render() {
    const { classes, children } = this.props;

    return <div className={classes.actions}>{children}</div>;
  }
}

SidebarActions.propTypes = sharedPropTypes;

const StyledSidebarHeader = withStyles(styles)(SidebarHeader);
const StyledSidebarTitle = withStyles(styles)(SidebarTitle);
const StyledSidebarTypography = withStyles(styles, {
  name: 'AppSidebarTypography',
})(SidebarTypography);
const StyledSidebarActions = withStyles(styles)(SidebarActions);

export default withStyles(styles)(Sidebar);
export {
  StyledSidebarHeader as SidebarHeader,
  StyledSidebarTitle as SidebarTitle,
  StyledSidebarTypography as SidebarTypography,
  StyledSidebarActions as SidebarActions,
};
